import React from 'react';
import ServiceAddPres from '../../ServiceInit/presentational/ServiceAddPres';
import intl from 'react-intl-universal';

export const SummaryPage = ({}) => {
  return (
    <React.Fragment>
      <div className="summary-page">
        <hr />

        <h4>{intl.get('consent.summary')}</h4>

        <hr />

        <p>{intl.get('consent.downloadThanks')}</p>
      </div>
    </React.Fragment>
  );
};

ServiceAddPres.propTypes = {};

export default SummaryPage;



// WEBPACK FOOTER //
// ./src/ui/features/Consent/presentational/SummaryPage.js